import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import SearchContacts from '../NewPersonalChat/SearchContacts';
import { useGetFriendsByUserIdQuery } from '../../../../store/apiSlice/friendApi';
import { Box } from '@mui/material';
import CustomButton from '../../../../components/MUIComponents/CustomButton';
import { ButtonTypeEnum } from '../../../../enums/button-type-enum';
import { useThemeContext } from '../../../../theme/ThemeContextProvider';
import { ICreateGroupChat } from './NewGroupChat';
import { IFriend } from '../../../../interfaces/friend.interface';
import ChatSuggestionsList from '../ChatSuggestionsList/ChatSuggestionsList';
import { mapFriendToUser } from '../ChatSuggestionsList/suggestionsUtils';
import useDebounce from '../../../../hooks/useDebounce';

interface IChatMembersFormProps {
  setFormData: Dispatch<SetStateAction<Partial<ICreateGroupChat>>>;
  setStep: Dispatch<SetStateAction<number>>;
}

const ChatMembersForm = ({ setFormData, setStep }: IChatMembersFormProps) => {
  const { theme } = useThemeContext();
  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedFriends, setSelectedFriends] = useState<IFriend[]>([]);

  const debouncedSearch = useDebounce(searchValue, 500);
  const { data } = useGetFriendsByUserIdQuery({
    page: 1,
    limit: 10,
    search: debouncedSearch,
    sort: 'desc',
  });

  const handleSelectFriend = (friend: IFriend) => {
    if (selectedFriends.some(user => user.userId === friend.userId)) {
      setSelectedFriends(prev =>
        prev.filter(user => user.userId !== friend.userId)
      );
    } else {
      setSelectedFriends(prev => [...prev, friend]);
    }
  };

  const handleSubmitForm = () => {
    setFormData(prev => ({
      ...prev,
      members: selectedFriends.map(mapFriendToUser),
    }));
    setStep(prev => prev + 1);
  };

  return (
    <>
      <SearchContacts
        onSearch={(e: ChangeEvent<HTMLInputElement>) =>
          setSearchValue(e.target.value)
        }
      />

      <ChatSuggestionsList
        friends={data?.friends ?? []}
        onClick={handleSelectFriend}
        selectedFriends={selectedFriends}
      />

      <Box
        display={'flex'}
        justifyContent={'space-between'}
        p={'1rem'}
        borderTop={`1px solid ${theme.palette.background.dark}`}
      >
        <CustomButton
          type="button"
          variantType={ButtonTypeEnum.SECONDARY}
          buttonWidth={'220px'}
          onClick={() => {
            setStep(prev => prev - 1);
          }}
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={handleSubmitForm}
          buttonWidth={'220px'}
          disabled={selectedFriends.length === 0}
        >
          Create chat
        </CustomButton>
      </Box>
    </>
  );
};

export default ChatMembersForm;
